export default "__VITE_ASSET__dkEOOYxR__"